/**
 * hata-uyarisi.tsx
 *
 * NE İŞE YARAR : Bir hata mesajını ekranda gösteren tek bileşen
 * KAYNAK SPEC  : 15-arayuz-standardi.md §9.1 (hata mesajı kuralı) · §13 (hata bildirimi
 *                metin + ikon, **yalnız renkle değil**) · 04-api-sozlesmesi.md §2.5
 * BAĞLI OLDUĞU : @mantine/core · @tabler/icons-react · src/api/hata.ts · src/metin
 * KULLANAN     : Bütün ekranlar
 * DİKKAT       : 1) HATA YALNIZ RENKLE BELİRTİLMEZ (`15` §13). Kırmızı bir çerçeve,
 *                   renk körü bir kullanıcı için hiçbir şey söylemez; bu yüzden ikon ve
 *                   metin birlikte bulunur ve ikisi de kaldırılamaz.
 *                2) MESAJ SUNUCUDAN GELİR (`15` §9.1). Bileşen metni **yazmaz**, gelen
 *                   metni gösterir. `04` §9 her kısıt için kullanıcı mesajını sunucu
 *                   tarafında tanımlıyor; arayüzün kendi cümlesini yazması iki metnin
 *                   ayrışması demektir.
 *                3) `correlation_id` KÜÇÜK VE İKİNCİL GÖSTERİLİR (`04` §2.5). Kullanıcıya
 *                   bir şey anlatmaz ama kullanıcının bildirdiği hatayı sunucu log'unda
 *                   bulmanın tek yoludur. Öne çıkarılsaydı ekranın asıl mesajı
 *                   gölgelenirdi.
 *                4) `role="alert"` BİLİNÇLİDİR: ekran okuyucu, hata belirdiğinde
 *                   kullanıcının odağını bozmadan metni okur. Mantine `Alert`i bunu
 *                   kendiliğinden yapmaz.
 * SON GÜNCELLEME: 2026-08-31 03:35:00
 */
import { Alert, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactElement } from 'react';

import { ApiHatasi } from '../../api/hata';
import { metin } from '../../metin';

export function HataUyarisi({
  mesaj,
  hata,
}: {
  /** Ekranın bağlama özgü mesajı; verilmezse `hata.message` gösterilir. */
  mesaj?: string | null;
  hata?: unknown;
}): ReactElement | null {
  const apiHatasi = hata instanceof ApiHatasi ? hata : null;
  const gosterilecek = mesaj ?? apiHatasi?.message ?? (hata === undefined ? null : metin('hata.beklenmeyen'));

  if (gosterilecek === null || gosterilecek === '') {
    return null;
  }

  return (
    <Alert
      color="hata"
      variant="light"
      icon={<IconAlertTriangle size={18} />}
      role="alert"
      radius="sm"
    >
      <Text size="sm">{gosterilecek}</Text>
      {apiHatasi?.correlationId === undefined ? null : (
        // Başlıktaki not 3 — ikincil, küçük, ama kaldırılmaz.
        <Text size="xs" c="notr.6" mt="xs">
          {metin('hata.izlemeKodu', { kod: apiHatasi.correlationId })}
        </Text>
      )}
    </Alert>
  );
}
